// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"25c40759","455":"42cdba44","977":"be0ac299"}[chunkId] + ".chunk.js";
};